import { render } from "./ProposalShow.vue?vue&type=template&id=e744e2b6"
import script from "./ProposalShow.vue?vue&type=script&lang=js"
export * from "./ProposalShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__